import { BorderRadius, Color } from '@billy/design-system'
import { StyleSheet } from '@react-pdf/renderer'
import type { Style } from '@react-pdf/types'

interface GetTableHeaderRowCellPdfStylesProps {
  minWidth?: number
  shouldHaveLastColumnStyles: boolean
}

export const getTableHeaderRowCellPdfStyles = ({
  minWidth,
  shouldHaveLastColumnStyles,
}: GetTableHeaderRowCellPdfStylesProps): Style => {
  const pdfStyles = StyleSheet.create({
    tableHeaderRowCell: {
      minWidth: minWidth || 'auto',
      padding: 12,
      borderBottomWidth: 1,
      borderTopLeftRadius: BorderRadius.R8,
      borderTopRightRadius: BorderRadius.R8,
      ...(shouldHaveLastColumnStyles && { borderRightWidth: 1, textAlign: 'right' }),
      borderColor: Color.Grey200,
      flex: 1,
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: Color.White,
      fontWeight: 'bold',
      wordBreak: 'break-word',
    },
  })

  return pdfStyles.tableHeaderRowCell
}
